<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">Access Control Lists</div>
        <div class="section-subTitle my-2">Grant access to user based in permission.</div>
      </div>
      <div></div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center justify-content-between w-100">
        <div>
          <b-form-input v-debounce:300="getRolesList" v-model="searchValue" placeholder="Search..."></b-form-input>
        </div>
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{selectedvalue}}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
            >{{list.name}}</b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </div>

    <div class>
      <table class="list-view-table">
        <thead>
          <tr>
            <th>Roles</th>
            <!-- <th class="text-right">
              <span class="pr-5">{{ $tc('active')}}</span>
            </th>-->
          </tr>
        </thead>
        <tbody>
          <tr v-for="(Role , userLoopKey) in Roles" :key="userLoopKey">
            <td>{{ Role.role_name }}</td>
            <td>
              <div class="d-flex align-items-center justify-content-end">
                <!-- <b-checkbox switch></b-checkbox> -->

                <b-dropdown right variant="edit" class="ml-4">
                  <b-dropdown-item v-on:click="onEditRole(Role)">
                    <span class="edit-pen mr-1"></span>
                    {{ $t('edit') }}
                  </b-dropdown-item>
                  <!-- <b-dropdown-item to="view-access-control">
                    <span class="icon-eye mr-1"></span>
                    {{ $t('view') }}
                  </b-dropdown-item>-->
                </b-dropdown>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>
<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      searchValue: "",
      showcurrentpassword: true,
      shownewpassword: false,
      password: "",
      submitted: false,
      selectUser: "",
      epassword: "",
      cpassword: "",

      gridView: false,
      listView: true,
      users: [],
      Cinemas: [],
      cinemaname: "",
      rolename: "",
      CinemasMethods: {
        GET: "/admin/",
        tableName: "ms_cinemas",
        urlKey: "cinemas",
      },
      Roles: [],
      RolesMethod: {
        GET: "/admin/",
        tableName: "ms_roles",
        urlKey: "roles",
      },
      userid: "",
      viewingnumbers: [],
    };
  },
  mounted() {
    this.getRolesList();
    this.getviewingnumber();
  },

  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getRolesList();
      } else {
        this.currentPage = event;
        this.getRolesList();
      }
    },
    getRolesList: function () {
      // console.log("role_id :", role_id);
      this.Roles = [];
      let body = this.getRequestBody("GET", undefined, this.RolesMethod);
      body.url += `?searchKey=role_name&searchValue=${this.searchValue}&limit=${this.perPage}&currentPage=${this.currentPage}&flag=ACL`;
      MasterService.GlobalRequest(body)
        // MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              // this.Roles = data.Records;
              data.Records = data.Records.filter((x, i) => {
                if (
                  x.role_id != 1 &&
                  x.role_id != 2 &&
                  x.role_id != 3 &&
                  x.role_id != 4 &&
                  x.role_id != 8 &&
                  x.role_id != 9 &&
                  x.role_id != 10 &&
                  x.role_id != 11 &&
                  x.role_id != 12 &&
                  x.role_id>35
                ) {
                  return x;
                }
              });
              this.Roles = _.orderBy(data.Records, "role_id");
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
                this.selectedvalue = this.perPage;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onEditRole: function (Role) {
      this.$router.push({
        path: "/access-control-list/edit-access-control",
        query: { role_id: Role.role_id, role_name: Role.role_name },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/AccessControlList/accessControlListMaster.vue